import "./publicPath";
import Vue from "vue";
import { createPinia } from "pinia";
import { migrateLegacySession } from "@/auth/session";
import App from "./App";

import store from "./storex";
import router from "./router";

import apolloProvider from "./http/apollo";
import i18n from "./plugins/i18n";
import vuetify from "./plugins/vuetify";
import "./http";
import "./plugins";

Vue.config.productionTip = false;

// Sessões antigas (tokens no localStorage) viram sessão de cookie no BFF
migrateLegacySession();

const pinia = createPinia();

const vm = new Vue({
  router,
  store,
  pinia,
  apolloProvider,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

globalThis.$vm = vm;
